module.exports = __webpack_public_path__ + "static/img/calls-taken-en.a90a069.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/calls-taken-en.png
// module id = VF/d
// module chunks = 0